<template>
  <img
    v-on-clickaway="away"
    class="big-image"
    :style="styleObj"
    :class="classObj"
    :src="src"
    alt=""
  />
</template>

<script>
import wait from 'waait'
import imagesLoaded from 'imagesloaded'
import debounce from 'lodash/debounce'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'BigImage',

  mixins: [clickaway],

  props: {
    src: {
      default: null,
      type: String,
      required: true
    }
  },

  data() {
    return {
      opened: false,
      x: 0,
      y: 0
    }
  },

  computed: {
    classObj() {
      return {
        'is-opened': this.opened
      }
    },

    styleObj() {
      return {
        left: `${this.x}px`,
        top: `${this.y}px`
      }
    }
  },

  created() {
    this.debouncedResize = debounce(this.resize, 250)
  },

  mounted() {
    imagesLoaded(this.$el, this.layout)
    window.addEventListener('resize', this.debouncedResize, { passive: true })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedResize, {
      passive: true
    })
  },

  methods: {
    async layout() {
      const buffer = 40
      const w = this.$el.clientWidth
      const h = this.$el.clientHeight
      const winW = window.innerWidth - buffer
      const winH = window.innerHeight - buffer
      const randX = Math.floor(Math.random() * (winW - w))
      const randY = Math.floor(Math.random() * (winH - h))
      this.x = randX
      this.y = randY
      if (!this.opened) {
        await wait(50)
        this.opened = true
      }
    },

    resize() {
      this.layout()
    },

    away() {
      this.opened = false
      this.$emit('close')
    }
  }
}
</script>

<style>
.big-image {
  height: auto !important;
  max-height: 80%;
  max-width: 80%;
  opacity: 0;
  position: fixed;
}

.big-image.is-opened {
  opacity: 1;
}

@media (max-width: 640px) {
  .big-image {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
  }
}
</style>
